import '@babel/polyfill';
import document from 'global/document';
import React from 'react';
import ReactDOM from 'react-dom';
import '~client/settings/axios';
import { cdnHost } from '~client/settings/endpoints';
import App from '~client/app';
import getStaticHash from '~helpers/static-hash';
import importScript from '~helpers/import-script';
import { init as initTrack } from '~helpers/mixpanel';
import './antd.less';
import './index.scss';
import cookies from 'js-cookie';
import { cookieNames } from '~constants/storage';
import { initSentry } from 'common/utils/sentry';
import { systemName } from 'common/constants/system';

initSentry(systemName.dashboard);
cookies.set(cookieNames.systemName, systemName.dashboard, { path: '/' });

// 解决window.open问题
let _open = window.open;
window.open = (uri, type) => {
  let _url = uri.indexOf('http') > -1 ? uri : process.env.PUBLIC_URL + uri;
  _open(_url, type);
};

getStaticHash(`${cdnHost()}`)
  .then(() => {
    let cdnHost = 'https://storm-frontend-cdn.dandythrust.com';

    if (window.location.host.includes('student')) {
      cdnHost = 'https://cdn.student.com';
    }
    return importScript(`${cdnHost}/app/trak/dist/trak.${window.hurricane.staticHash.trak}.js`);
  })
  .finally(() => {
    initTrack();
    ReactDOM.render(<App />, document.getElementById('app'));
  });
